import { TripsLayer } from '@deck.gl/geo-layers';
import * as uuid from 'uuid';

import { FsTimeService } from '@lib/common/services';

type PointsType = {
  coordinates: number[];
  timestamp: number;
};

export class FsDeckGLBreadcrumb {
  public points: PointsType[] = [];
  public length: number;
  public layers: TripsLayer[] = [];
  public tripLayer: TripsLayer;

  constructor(
    public trail: {
      points: any;
      color: number[];
      frequency: number;
      thickness: number;
      layerName: string;
    },
  ) {
    this.length = this.trail.points.formmattedResults?.length;
    const firstPointTime = new Date(this.trail.points.formmattedResults[this.length - 1].timestamp);
    const unixPointTime = new FsTimeService().convertToUnixTimestampSeconds(firstPointTime);
    this.points = this.trail.points.formmattedResults?.map((point) => {
      const date = new Date(point.timestamp);
      const timestamp = new FsTimeService().convertToUnixTimestampSeconds(date) - unixPointTime;
      return {
        coordinates: [point.lon, point.lat],
        timestamp,
      };
    });

    this.createLayer();
  }

  public createLayer(): void {
    const tripData = [
      {
        path: this.points.map((point) => point.coordinates),
        timestamps: this.points.map((point) => point.timestamp),
      },
    ];

    const averageTime =
      tripData[0].timestamps.reduce((sum, value) => sum + value, 0) / this.points.length;

    const trip = new TripsLayer({
      id: `trips-layer-${this.trail.layerName}`,
      data: tripData,
      getPath: (d) => d.path,
      getTimestamps: (d) => d.timestamps,
      getColor: () => this.trail.color,
      currentTime: averageTime,
      trailLength: averageTime / 2,
      capRounded: true,
      jointRounded: true,
      widthMinPixels: 8,
    });

    this.layers.push(trip);
    this.tripLayer = trip;
  }
}
